import ToggleBox from './togglebox.vue'
export default ToggleBox
